import { render } from "./add-question.vue?vue&type=template&id=27f8073e&scoped=true"
import script from "./add-question.vue?vue&type=script&lang=js"
export * from "./add-question.vue?vue&type=script&lang=js"

import "./add-question.vue?vue&type=style&index=0&id=27f8073e&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27f8073e"]])

export default __exports__